import { useMemo } from 'react';
import { DealPostType, OptionType } from '@types';
import { categoryAll, isSingleCategoryAll, sortDeals } from '@utils/index';
import { filterByCategory } from '../Deals/utils';

export const defaultCategories = [categoryAll];

export const isSubscribeAndSavePage = (slug: string) =>
  slug === 'best-subscribe-save-deals-amazon';
export const isPromotionsPage = (slug: string) =>
  slug === 'amazon-special-promotions';
export const isDiapersPage = (slug: string) =>
  slug === 'amazon-deals-amazon-deals-diapers';

const useFilteredSortedDeals = (
  deals: DealPostType[],
  categoryFilters: OptionType[],
  sortOrder: string,
  searchTerm: string,
  promotionFilter: string,
  couponFilter: string,
  brandFilter: string,
  sizeFilter: string,
  isPromotions: boolean,
  isDiapers: boolean,
  showBrandFilter: boolean,
  showCategoryFilter: boolean | undefined,
  showCouponFilter: boolean
) => {
  const sortedItems = useMemo(() => {
    return sortDeals(deals, sortOrder);
  }, [deals, sortOrder]);

  const filteredItems = useMemo(() => {
    let items = sortedItems;

    if (
      !isSingleCategoryAll(categoryFilters?.[0]) &&
      showCategoryFilter !== false
    ) {
      items = filterByCategory(
        categoryFilters.map((cat) => cat.value) as unknown as string[],
        sortedItems
      );
    }

    if (isPromotions && promotionFilter !== 'all') {
      items = items.filter((deal) => deal.extraDealLink === promotionFilter);
    }

    if (showCouponFilter && couponFilter !== 'all') {
      items = items.filter((deal) => {
        return deal.promoCode === couponFilter;
      });
    }

    if (isDiapers && sizeFilter !== 'all') {
      items = items.filter((deal) => deal.sizeTerm === sizeFilter);
    }

    if (searchTerm) {
      items = items.filter(
        (deal) => deal.title?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // there's a brand named "all" so we need to check for that
    if (showBrandFilter && brandFilter !== 'ALL_BRANDS') {
      items = items.filter((deal) => deal.brand === brandFilter);
    }

    return items;
  }, [
    sortedItems,
    categoryFilters,
    promotionFilter,
    couponFilter,
    brandFilter,
    sizeFilter,
    searchTerm,
    isPromotions,
    isDiapers,
    showBrandFilter,
    showCategoryFilter,
    showCouponFilter
  ]);

  return filteredItems;
};

export default useFilteredSortedDeals;
